<template>
  <div class="box">
    <div class="wifi-symbol">
      <div class="wifi-circle first"></div>
      <div class="wifi-circle second"></div>
      <div class="wifi-circle third"></div>
      <audio ref="audio" preload="auto" :src="url" class="audio"></audio>
    </div>
  </div>
</template>

<script>
export default {
  name: "course-item",
  props: {
    url: {
      type: String,
      default: ""
    }
  },
  methods: {
    play() {
      return this.$refs.audio;
    }
  }
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.box
    display inline-flex
    position: relative;
    &.active
        .wifi-symbol
            .wifi-circle
                &.second
                    animation: fadeInOut 1s infinite 0.2s;
                &.third
                    animation: fadeInOut 1s infinite 0.4s;
    .wifi-symbol
        position relative;
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        overflow: hidden;
        transform: translateZ(0) rotate(135deg);
        .audio
            display none
            width 0
        .wifi-circle
            border: 5px solid #3480FF;
            border-radius: 50%;
            position: absolute;
            &.first
                width: 5px;
                height: 5px;
                background: #3480FF
                top: 45px;
                left: 45px;
            &.second
                width: 25px;
                height: 25px;
                top: 35px;
                left: 35px;
            &.third
                 width: 40px;
                 height: 40px;
                 top: 25px;
                 left: 25px;
@keyframes fadeInOut
    0%
        opacity: 0;
    100%
        opacity: 1;
</style>
